<ng-container *ngIf="detailHeaderSubject | async as detail">
  <ng-container [ngSwitch]="detail.status_enum">
    <ng-container *ngSwitchCase="DistributorStatusEnum.PENDING_REGISTRATION" [ngTemplateOutlet]="adminViewTpl"></ng-container>
    <ng-container *ngSwitchCase="DistributorStatusEnum.PENDING_EDIT_VERIFICATION" [ngTemplateOutlet]="adminViewTpl"></ng-container>
    <ng-container *ngSwitchCase="DistributorStatusEnum.PENDING_REGISTRATION_FINANCE" [ngTemplateOutlet]="financeViewTpl"></ng-container>
  </ng-container>
</ng-container>

<ng-template #adminViewTpl>
  <ng-container>
    <mat-stepper #stepper (selectionChange)="onStepChange($event)" [animationDuration]="'150'" [disableRipple]="true" [linear]="true" class="my-0">
      <!--  STEP 1 - DATA DISTRIBUTOR -->
      <mat-step [stepControl]="distributorDataForm" label="Data Distributor" [state]="activeStepIndex === 0 ? 'edit' : 'number'">
        <ng-container *ngIf="activeStepIndex === 0">
          <app-distributor-data [form]="distributorDataForm"></app-distributor-data>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: distributorDataForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 2 - DATA USAHA -->
      <mat-step [stepControl]="businessDataForm" label="Data Usaha" [state]="activeStepIndex === 1 ? 'edit' : 'number'">
        <ng-container *ngIf="activeStepIndex === 1">
          <app-business-data [form]="businessDataForm"></app-business-data>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: businessDataForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 3 - PLAFON KREDIT -->
      <mat-step [stepControl]="creditCeilingForm" label="Plafon Kredit" [state]="activeStepIndex === 2 ? 'edit' : 'number'">
        <ng-container *ngIf="activeStepIndex === 2">
          <app-credit-ceiling [form]="creditCeilingForm"></app-credit-ceiling>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: creditCeilingForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 4 - ALAMAT PENGIRIMAN -->
      <mat-step [stepControl]="shippingAddressForm" label="Alamat Pengiriman" [state]="activeStepIndex === 3 ? 'edit' : 'number'">
        <ng-container *ngIf="activeStepIndex === 3">
          <app-shipping-address [form]="shippingAddressForm"></app-shipping-address>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: shippingAddressForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 5 - DOKUMEN -->
      <mat-step [stepControl]="documentForm" label="Dokumen" [state]="activeStepIndex === 4 ? 'edit' : 'number'">
        <ng-container *ngIf="activeStepIndex === 4">
          <app-document [form]="documentForm" [status]="headerValue.status_enum"></app-document>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: documentForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <ng-template #btnStepTpl let-index="i" let-isValid="isValid">
        <div class="d-flex justify-content-between align-items-center">
          <button *ngIf="index !== 0" [class]="'btn btn-outline text-primary min-w-150px'" matStepperPrevious>Sebelumnya</button>
          <button
            *ngIf="index < 4 || (index === 4 && showBtnGroup())"
            (click)="index === 4 ? handleConfirm() : stepper.next()"
            [class]="'btn btn-primary min-w-150px' + (index === 0 ? ' ms-auto' : '')"
            [disabled]="!isValid"
          >
            {{ index === 4 ? 'Konfirmasi' : 'Selanjutnya' }}
          </button>
        </div>
      </ng-template>
    </mat-stepper>
  </ng-container>
</ng-template>

<ng-template #financeViewTpl>
  <mat-tab-group (selectedIndexChange)="handleTabChange($event)" [(selectedIndex)]="tabIndex" animationDuration="0ms" class="line mt-8" mat-stretch-tabs="false">
    <ng-container *ngFor="let tab of tabList; index as i">
      <mat-tab *ngIf="tab['privilege']" [label]="utilities.mapKeyToString(TabListLabelDetailDistributor, tab['labelKey'])">
        <ng-container *ngIf="i === tabIndex && tab.component">
          <ng-container *ngComponentOutlet="tab.component"></ng-container>
        </ng-container>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
</ng-template>

<app-modal #modalConfirmRegistration [modalConfig]="modalConfigConfirmRegistration" [modalOptions]="{ size: 'md' }">
  <div>
    <span>Apakah anda yakin mengonfirmasi Distributor:</span>
    <div class="my-4">
      <div class="mb-2 d-flex">
        <div class="min-w-200 text-gray-600">Nama Distributor</div>
        <div>: {{ headerValue.business_name }}</div>
      </div>
      <div class="mb-2 d-flex">
        <div class="min-w-200 text-gray-600">Cakupan</div>
        <div>: {{ headerValue.sales_sub_area + ', ' + headerValue.sales_area }}</div>
      </div>
      <div class="d-flex">
        <div class="min-w-200 text-gray-600">Regional Head</div>
        <div>: {{ headerValue.regional_head_name }}</div>
      </div>
    </div>
    <div *ngIf="revisionNote.value.length <= 0">Setelah dikonfirmasi, Distributor akan diteruskan ke Finance. Pastikan semua data telah lengkap dan benar.</div>
  </div>
  <ng-container *ngIf="revisionNote | async as revisionNote">
    <ng-container *ngIf="revisionNote.length > 0">
      <div class="d-flex my-4">
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER" class="svg-icon svg-icon-24"></span>
        <div class="ms-4 fw-bold">Catatan Perbaikan</div>
      </div>
      <div *ngFor="let item of revisionNote" class="mb-2 d-flex">
        <div class="min-w-200 text-gray-600">{{ item.label }}</div>
        <div>: {{ item.value }}</div>
      </div>
    </ng-container>
  </ng-container>
</app-modal>

<app-modal #modalResponse [modalConfig]="modalConfigResponse">
  <ng-container modalBody>
    <div class="d-flex flex-column justify-content-center align-items-center">
      <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT"></span>
      <div class="text-center">{{ generateResponseSuccess() }}</div>
    </div>
  </ng-container>
</app-modal>
